import {
  LayoutDashboard,
  ShoppingCart,
  Package,
  FileText,
  User,
  BarChart3,
  Bell,
  Users,
  HelpCircle,
  CreditCard,
  Repeat,
} from 'lucide-react';

export const navItems = [
  { path: '/client/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/client/shop', label: 'Shop', icon: ShoppingCart },
  { path: '/client/orders', label: 'Orders', icon: Package },
  { path: '/client/recurring-orders', label: 'Recurring Orders', icon: Repeat },
  { path: '/client/invoices', label: 'Invoices', icon: FileText },
  { path: '/client/payment-methods', label: 'Payment Methods', icon: CreditCard },
  { path: '/client/messages', label: 'Messages', icon: Bell },
  { path: '/client/reports', label: 'Reports', icon: BarChart3 },
  { path: '/client/profile', label: 'Profile', icon: User },
  { path: '/client/team', label: 'Team', icon: Users },
  { path: '/client/help', label: 'Help Center', icon: HelpCircle },
];
